import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { FiltersGrid } from '../types';
import { ReportTemplate, ReportTemplateRequestBody } from './types';

export const reportTemplatesApi = createApi({
  reducerPath: 'reportTemplatesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_ANALYTICS_API_URL}/report-templates`,
  }),
  tagTypes: ['ReportTemplate', 'ReportTemplates'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getReportTemplates: builder.query<ReportTemplate[], FiltersGrid | void>({
      query: (params = {}) => {
        return {
          url: `/query`,
          params,
        };
      },
      providesTags: () => ['ReportTemplates'],
    }),
    getReportTemplateById: builder.query<ReportTemplate, string>({
      query: id => ({
        url: `/${id}`,
      }),
      providesTags: () => ['ReportTemplate'],
    }),
    createReportTemplate: builder.mutation<
      ReportTemplate,
      ReportTemplateRequestBody
    >({
      query: data => ({
        url: '/',
        method: 'POST',
        data,
      }),
      invalidatesTags: () => ['ReportTemplates'],
    }),
    updateReportTemplate: builder.mutation<
      ReportTemplate,
      ReportTemplateRequestBody
    >({
      query: data => ({
        url: `/${data.id}`,
        method: 'PUT',
        data,
      }),
      invalidatesTags: result => [
        'ReportTemplates',
        { type: 'ReportTemplate', id: result?.id },
      ],
    }),
    deleteReportTemplate: builder.mutation<ReportTemplate, string>({
      query: id => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_, __, id) => [
        'ReportTemplates',
        { type: 'ReportTemplate', id },
      ],
    }),
  }),
});

export const {
  useGetReportTemplatesQuery,
  useGetReportTemplateByIdQuery,
  useCreateReportTemplateMutation,
  useUpdateReportTemplateMutation,
  useDeleteReportTemplateMutation,
} = reportTemplatesApi;
